import axios from 'axios';
import { IItem } from '../store/state'

const SitevisionHeader = {
  'X-Requested-With': 'XMLHttpRequest',
  'Accept': 'application/json',
}

const BASE_URL = '';

export interface ISearchParams {
  numberToShow: number,
  sortBy: string,
  start?: string,
  end?: string,
  operations: string,
  subjects: string,
  themes: string,
  blogNames: string,
  [key: string]: any;
}

interface ISearchResObj {
  items: IItem[],
  total: number,
}

export const search = (url: string, params: ISearchParams): Promise<ISearchResObj> => {
  const searchParams = new URLSearchParams(params as any).toString();

  return axios.post(`${BASE_URL}${url}`, searchParams, {
    headers: {
      ...SitevisionHeader,
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  })
  .then(response => response.data)
  .catch(searchError => {
    console.error("ERROR:" + JSON.stringify(searchError));
    return {} as ISearchResObj;
  });
}
